import { render, staticRenderFns } from "./CustomProviderTariff.vue?vue&type=template&id=c5c00d32&"
import script from "./CustomProviderTariff.vue?vue&type=script&lang=ts&"
export * from "./CustomProviderTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports